export default {
  back: 'Kembali',
  exit: 'Keluar',
  next: 'Selanjutnya',
  yes: 'Ya',
  no: 'Tidak',
  cancel: 'Batal',
  edit: 'Ubah',
  process: 'Proses',
  save: 'Simpan',
  delete: 'Hapus',
  createdBy: 'Dibuat Oleh',
  updatedBy: 'Diubah Oleh',
  status: 'Status',
  statusOptions: [
    {
      value: true,
      label: 'Active'
    },
    {
      value: false,
      label: 'Inactive'
    }
  ],
  list: 'Daftar',
  user: 'User',
  userList: 'Daftar User',
  transporter: 'Rekanan 3PL',
  shipper: 'Customer',
  currency: 'Rp',
  commonTablePagination: (page, length, size, totalEntry) => {
    if (length >= 1) {
      if (page === 1 && totalEntry <= size) {
        return (`1 - ${length} dari ${totalEntry}`)
      }
      if (page === 1) {
        return (`1 - ${size} dari ${totalEntry}`)
      }
      if (page >= 2) {
        const from = (page - 1) * size + 1
        const to = from + (length - 1)
        return (`${from} - ${to} dari ${totalEntry}`)
      }
    }
    return ''
  },
}
